import { api } from '../lib/api';

interface PaymentData {
  id?: number;
  orgId: string;
  smLink: string;
  firstName: string;
  lastName: string;
  amount: string;
  paymentDate: string;
  createdAt?: string;
}

export const paymentsService = {
  // Fetch payments as structured data (database only - no Google Sheets fallback)
  async fetchPaymentsData(orgId: string): Promise<PaymentData[]> {
    try {
      const dbResponse = await api.payments.fetchByOrgId(orgId);
      return dbResponse.payments;
    } catch (error) {
      console.error('Error fetching payments data:', error);
      throw error;
    }
  },

  // Get payment statistics
  async getPaymentStats(orgId: string): Promise<{ totalPayments: number; totalAmount: number }> {
    try {
      const dbResponse = await api.payments.fetchByOrgId(orgId);
      return dbResponse.stats;
    } catch (error: any) {
      console.error('Error fetching payment stats:', error);
      return { totalPayments: 0, totalAmount: 0 };
    }
  },

  // Add a new payment
  async addPayment(payment: Omit<PaymentData, 'id' | 'createdAt'>): Promise<any> {
    return await api.payments.add(payment);
  },

  // Delete a payment
  async deletePayment(orgId: string, paymentId: number): Promise<any> {
    try {
      const result = await api.payments.delete(orgId, paymentId);
      return result;
    } catch (error) {
      throw error;
    }
  }
};

export default paymentsService;
